import Api from './api'

export default {

    get: function () {

        return Api.get('/v3/agreements')

    },

    update: function (page) {

        return Api.put(`/v3/agreements/${page}`)

    }
}